import React,{useEffect,useState} from 'react'
import firebase from 'firebase/compat';
import "../App.css";
import moment from "moment";

function Ack() {

    const [user_list, setuser_list] = useState([]);

    const [loading, setLoading] = useState(true);
    useEffect(() => {
  
      const subscriber = firebase.firestore()
        .collection('ack')
        .orderBy('timestamp','desc')
        .onSnapshot(querySnapshot => {
          const t_list_ = [];
          querySnapshot.forEach(doc => {
               t_list_.push({
                  ...doc.data(),
                   key: doc.id
              });
          });
          setuser_list(t_list_);
          setLoading(false);
        });
      return () => subscriber();
    }, []); 

  
    
  return (
    <div>
        <div className="curr_market">
                <div className="mkt_head">
                    <h1>User <mark className="color_blue">Interested</mark></h1>
                   
                </div>
                <div className="mkt_grid_section">
                  

                    <div className='mk_grid'>
                    <div className='stock_comp_head user_comp'>
                        <h5>PROFILE</h5>
                        <h5>NAME</h5>
                        <h5>EMAIL</h5>
                        <h5>TIMESTAMP</h5>
                      
                    </div>
                    {user_list.map((item,index) => (

                            <div className="user_comp" key={item.key}>
                                <img src={item.img} alt="" />
                                <p>{item.name}</p>
                                <p>{item.email}</p>
                                <p>{moment(item.timestamp).format("LLL")}</p>
                            </div>

                            ))}

                    </div>
                </div>
            </div>
    </div>
  )
}

export default Ack